module.exports = __webpack_public_path__ + "media/img/pages/profile/axpo ger 13-5100d30c81116cec644cc59630237c4d.jpg";